import * as R from "ramda";
import React, {Component} from "react";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import MasterLogistikTable from "../common/masterLogistikTable";
import {formGroupType, tableConfig} from "../config";
import Api from "../../../../Services/Api";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import MasterLogistikMotorTypeModifying from "./modal/MasterLogistikMotorTypeModifying";
import {flattenFormGroupObject, getValueFromDDL, mapToObjectDDL} from "../../../common/mapper";
import {fetchDataAsync} from "../../../../Services/Utils";
import {HttpStatus} from "../../../common/Constants";

class MasterLogistikMotorType extends Component {
    dummyDataSeries = [
        {
            id: 1,
            segmentName: "CUB",
            subSegmentName: "Mid",
            seriesName: "Scoopy",
            status: "ACTIVE",
        },
        {
            id: 2,
            segmentName: "Matic",
            subSegmentName: "Low",
            seriesName: "Matic",
            status: "ACTIVE",
        },
        {
            id: 3,
            segmentName: "Sporty",
            subSegmentName: "High",
            seriesName: "Big Bike",
            status: "INACTIVE",
        },
        {
            id: 4,
            segmentName: "Call content",
            subSegmentName: "Mid",
            seriesName: "Vespa",
            status: "INACTIVE",
        }
    ];

    dummyDataType = [
        {
            id: 1,
            seriesName: "Scoopy",
            typeName: "prestige",
            status: "ACTIVE",
        },
        {
            id: 2,
            seriesName: "Matic",
            typeName: "ordinary",
            status: "ACTIVE",
        },
        {
            id: 3,
            seriesName: "Big Bike",
            typeName: "like",
            status: "INACTIVE",
        },
        {
            id: 4,
            seriesName: "Vespa",
            typeName: "subscribe",
            status: "INACTIVE",
        }
    ]

    constructor(props) {
        super(props);
        this.tableConfig = tableConfig.type;
        this.state = {
            modifyingVisible: false,
            selectedData: null,
            dataSeriesDDL: [],
            dataTable: [],
            pagination: {
                count: 0,
                limit: 5,
                page: 1,
                orderBy: "id",
                sort: "ASC",
            }
        };
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        await this.fetchDataType();
        this.handleTriggerLoading();
    }

    handleModifyingModalVisibility = async (index) => {
        this.handleTriggerLoading();
        if (!this.state.modifyingVisible) {
            await this.fetchDataSeries();
        }

        if (!R.isNil(index)) {
            let res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getTypeById,
                menuName: "Master Logistik Motor - Tipe",
                setError: this.props.setError,
                args: this.state.dataTable[index].id,
            });
            if (res.ok && res.data.status === HttpStatus.SUCCESS) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    selectedData: {
                        ...res.data.data,
                        idSeries: mapToObjectDDL(res.data.data.seriesDTO.seriesName, res.data.data.seriesDTO.id)
                    },
                    modifyingVisible: !prevValue.modifyingVisible,
                }));
            }
        } else {
            this.setState((prevValue) => ({
                ...prevValue,
                selectedData: null,
                modifyingVisible: !prevValue.modifyingVisible,
            }));
        }

        this.handleTriggerLoading();
    };

    handleSubmitModifying = async (controls) => {
        this.handleTriggerLoading();
        const formGroup = flattenFormGroupObject(controls);
        const requestBody = {
            ...formGroup,
            idSeries: getValueFromDDL(formGroup, "idSeries"),
        };
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").saveType,
            menuName: "Master Logistik Motor - Tipe",
            setError: this.props.setError,
            args: requestBody,
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.handleModifyingModalVisibility();
            await this.fetchDataType({
                paramFilters: {},
                page: this.state.pagination.page,
                limit: this.state.pagination.limit,
            });
        }
        this.handleTriggerLoading();
    };

    handleChangeStatus = async (index, value) => {
        this.handleTriggerLoading();
        let data = this.state.dataTable[index];
        data.status = value ? "ACTIVE" : "INACTIVE";
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").updateStatusType,
            menuName: "Master Logistik Motor - Tipe",
            setError: this.props.setError,
            args: {id: data.id, status: data.status}
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            await this.fetchDataType({
                paramFilters: {},
                page: this.state.pagination.page,
                limit: this.state.pagination.limit,
            });
        }
        this.handleTriggerLoading();
    };

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    handleChangePage = async (page, limit, callback) => {
        this.handleTriggerLoading();
        this.setState(callback);
        await this.fetchDataType({paramFilters: {}, page: page, limit: limit});
        this.handleTriggerLoading();
    }

    handleChangeRowsPerPage = async (page, limit, callback) => {
        this.handleTriggerLoading();
        this.setState(callback);
        await this.fetchDataType({paramFilters: {}, page: page, limit: limit});
        this.handleTriggerLoading();
    }

    fetchDataType = async (body) => {
        this.setState((prevValue) => ({...prevValue, pagination: {...prevValue.pagination, count: 0}}));
        let req = body && Object.keys(body).length > 0
            ? body :
            {
                paramFilters: {},
                page: 1,
                limit: 5,
            };
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllTypeByParam,
            menuName: "Master Logistik Motor - Tipe",
            setError: this.props.setError,
            args: req,
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState((prevState) => ({
                ...prevState,
                dataTable: res.data.data,
                pagination: {
                    ...prevState.pagination,
                    count: res.data.totalData,
                    page: req.page,
                    limit: req.limit,
                }
            }));
        }
    }

    fetchDataSeries = async () => {
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllSeries,
            menuName: "Master Logistik Motor - Tipe",
            setError: this.props.setError,
        });
        if (res.ok) {
            this.setState((prevState) => ({
                ...prevState,
                dataSeriesDDL: res.data.data.map(item => mapToObjectDDL(
                    item.seriesName,
                    item.id
                )),
            }));
        }
    }

    render() {
        return (
            <>
                <MasterLogistikTable
                    tableConfig={this.tableConfig}
                    menuAccess={this.props.menuAccess}
                    data={this.state.dataTable}
                    onEdit={this.handleModifyingModalVisibility}
                    onChangeStatus={this.handleChangeStatus}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    pagination={this.state.pagination}
                    additionalButtons={
                        this.props.menuAccess && this.props.menuAccess.createAccess && (
                            <SimpleButton
                                onClick={() => this.handleModifyingModalVisibility()}
                                icon={<i className="fa fa-plus margin-right-10px"></i>}
                                text={"Tambah"}
                            />
                        )
                    }
                />

                {this.state.modifyingVisible && (
                    <MasterLogistikMotorTypeModifying
                        formGroup={formGroupType}
                        initialValues={this.state.selectedData}
                        selectedData={this.state.selectedData}
                        dataSeriesDDL={this.state.dataSeriesDDL}
                        visible={this.state.modifyingVisible}
                        onSubmit={this.handleSubmitModifying}
                        onClickClose={this.handleModifyingModalVisibility}
                    />
                )}

                <SimpleLoadingOverlay active={this.state.loading}/>

            </>
        );
    }
}

export default MasterLogistikMotorType;
